import React, { createContext, useState } from 'react';
import { IconType } from 'react-icons/lib';
import { useSelector } from 'react-redux';
import { RootState } from 'types';
import Navbar from '.';

interface navItem {
  title: String;
  link: String;
  icon: IconType;
  selected?: boolean;
}

interface navbarConsumerProps {
  navItems: navItem[];
  setNavItems: React.Dispatch<React.SetStateAction<navItem[]>>;
  collapsed: boolean;
  setCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
  headerTitle: string;
  setHeaderTitle: React.Dispatch<React.SetStateAction<string>>;
}

export const navbarContext = createContext<navbarConsumerProps>({
  collapsed: true,
  setCollapsed: () => {},
  navItems: [],
  setNavItems: () => {},
  headerTitle: '',
  setHeaderTitle: () => {},
});

function NavbarProvider({ children }) {
  const { loggedIn, user } = useSelector((state: RootState) => state.session);
  const [collapsed, setCollapsed] = useState(true);
  const [navItems, setNavItems] = useState<navItem[]>([]);
  const [headerTitle, setHeaderTitle] = useState('');

  return (
    <navbarContext.Provider
      value={{
        collapsed,
        setCollapsed,
        navItems,
        setNavItems,
        headerTitle,
        setHeaderTitle,
      }}
    >
      {loggedIn && user.type === 'internal' ? (
        <Navbar navItems={navItems} collapsed={collapsed} />
      ) : null}
      {children}
    </navbarContext.Provider>
  );
}

export default NavbarProvider;
